export const NEW_OBJECT_ID_TOOL_NAME = "newObjectId";
